<template>
  <span></span>
</template>

<script>
    export default {
        name: "FooterMain"
    }
</script>

<style scoped>

</style>
